import React, { useEffect, useState } from 'react'
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { FaLocationDot } from "react-icons/fa6";
import L from 'leaflet';
import { renderToString } from 'react-dom/server';
import axios from 'axios';

const LocationMarker = ({ lokasiMasuk, lokasiPulang }) => {

    const [placeNameMasuk, setPlaceNameMasuk] = useState(null);
    const [placeNamePulang, setPlaceNamePulang] = useState(null);

    const iconMasukString = renderToString(<FaLocationDot style={{ color: 'green' }} size={30} />);
    const iconPulangString = renderToString(<FaLocationDot style={{ color: 'red' }} size={30} />);

    const customIconMasuk = new L.DivIcon({
        className: 'custom-marker-icon',
        html: `<div><span>${iconMasukString}</span></div>`,
    });

    const customIconPulang = new L.DivIcon({
        className: 'custom-marker-icon',
        html: `<div><span>${iconPulangString}</span></div>`,
    });

    useEffect(() => {
        const fetchPlaceNames = async () => {
            try {
                if (lokasiMasuk) {
                    const responseMasuk = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lokasiMasuk.latitude}&lon=${lokasiMasuk.longitude}`);
                    setPlaceNameMasuk(responseMasuk.data.display_name);
                }
                if (lokasiPulang) {
                    const responsePulang = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lokasiPulang.latitude}&lon=${lokasiPulang.longitude}`);
                    setPlaceNamePulang(responsePulang.data.display_name);
                }
            } catch (error) {
                console.error('Error fetching place names:', error);
            }
        };

        fetchPlaceNames();
    }, [lokasiMasuk, lokasiPulang]);

    const center = lokasiMasuk && lokasiPulang
        ? [
            (lokasiMasuk.latitude + lokasiPulang.latitude) / 2,
            (lokasiMasuk.longitude + lokasiPulang.longitude) / 2
        ]
        : lokasiMasuk
            ? [lokasiMasuk.latitude, lokasiMasuk.longitude]
            : [0, 0];

    return (
        <MapContainer
            center={center}
            zoom={17}
            style={{ height: '300px', width: '100%' }}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            {lokasiMasuk && (
                <Marker position={[lokasiMasuk.latitude, lokasiMasuk.longitude]} icon={customIconMasuk}>
                    <Popup>{placeNameMasuk || 'Loading...'}</Popup>
                </Marker>
            )}
            {lokasiPulang && (
                <Marker position={[lokasiPulang.latitude, lokasiPulang.longitude]} icon={customIconPulang}>
                    <Popup>{placeNamePulang || 'Loading...'}</Popup>
                </Marker>
            )}
        </MapContainer>
    );

};

export default LocationMarker
